import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function TeleportButtonDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  const positionId = data.positionId ?? null;
  const coords = data.mapSpot
    ? `X: ${data.mapSpot.x}, Y: ${data.mapSpot.y}, Z: ${data.mapSpot.z}`
    : null;

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Button Name"
        fieldKey="localizedPairs"
        data={data.localizedPairs}
        diffKeys={diffKeys}
        side={side}
      />

      <SectionBlock title="Map Placement" />
      <FieldRow
        label="Position Slot"
        value={positionId != null ? String(positionId) : '— (removed from map)'}
        isChanged={diffKeys.has('position')}
        side={side}
      />
      {coords && (
        <FieldRow
          label="Teleport Destination"
          value={coords}
          isChanged={false}
          side={side}
        />
      )}
    </Box>
  );
}
